import { commonEnvironment } from './common-environment'

const envName = 'beta'
const apiEnvName = 'test'

export const environment = {
  ...commonEnvironment,
  production: false,
  name: envName,
  loginUrl: `https://${envName}jean.alza.cz/login?email=`,
  signalR: {
    ...commonEnvironment.signalR,
    url: `https://${envName}jeansignalr.alza.cz/signalr/vendor`,
  },
  api: {
    ...commonEnvironment.api,
    baseUrl: `https://webapi.${apiEnvName}-dmz.alza.cz`,
    identityUrl: `https://${envName}identity.alza.cz`,
  }
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts